import { Col, Row, Form } from "react-bootstrap";
import BasicModal from "../../_widgets/Modal/BasicModal";
import Input from "../../_widgets/Input/Input";
import { warn } from "../../../Wrapper/toast/toast";
import { MAX_150_CHARS, maximumLengthAllowed } from "../../../Constants/stringConstants";

const EditMedicineCompanyModal = ({
  modalShow,
  setModalShow,
  handleClose,
  addMedicineData,
  addMedicine,
  editMedicine,
  buttonLoading,
  setAddMedicineData,
}) => {
  return (
    <BasicModal
      show={modalShow}
      size="md"
      setModalShow={setModalShow}
      handleClose={handleClose}
      heading={`${addMedicineData.action} Medicine Company`}
      footer
      button2Text="Save"
      button2Click={() =>
        addMedicineData.action === "Add" ? addMedicine() : editMedicine(addMedicineData.id)
      }
      loading={buttonLoading}
    >
      <div className="patients_ui">
        <Row>
          <Col xl={12}>
            <div className="white_card text-start">
              <Row className="mb-3">
                <Col lg={12}>
                  <Input
                    placeholder="Enter Medicine Company Name"
                    type="text"
                    label="Medicine Company Name"
                    value={addMedicineData.name}
                    onChange={(e) => {
                      if (e.target.value.length <= 100) {
                        setAddMedicineData({
                          ...addMedicineData,
                          name: e.target.value,
                        });
                      } else {
                        warn(maximumLengthAllowed(100));
                      }
                    }}
                  />
                </Col>
              </Row>
              <Row>
                <Col lg={12}>
                  <Form.Label>Description</Form.Label>
                  <Form.Control
                    as="textarea"
                    placeholder="Enter Description here"
                    rows={4}
                    value={addMedicineData.description}
                    onChange={(e) => {
                      if (e.target.value.length <= 150) {
                        setAddMedicineData({
                          ...addMedicineData,
                          description: e.target.value,
                        });
                      } else {
                        warn(MAX_150_CHARS);
                      }
                    }}
                  />
                </Col>
              </Row>
            </div>
          </Col>
        </Row>
      </div>
    </BasicModal>
  );
};

export default EditMedicineCompanyModal;
